import {Injectable} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NgxFileDropEntry } from 'ngx-file-drop';

@Injectable()
export class FormService {

    scheduledDateOfDelivery: NgbDateStruct | null = null;

    allItems = {
        cg: false,
        vr: false,
        animation: false,
        bim: false,
        other: false,
        projectName: '',
        vrItems : [],
        cgItems : [],
        animationItems : [],
        bimItems : [],
        otherItems : '',
        formData : [new FormData()],
        files : [] as NgxFileDropEntry[],
        timeOfDelivery : '',
        scheduledDateOfDelivery : this.scheduledDateOfDelivery,
        additionalUrls : '',
        commentOnDelivery: '',
        drawingNotAvailable: false,
        sunsetOrNightView: false,
        highQuality: false,
        managedBy: null,
        createdBy: null,
    };

    constructor() {
    }

    resetValueForFormServiceALLItems() {
        this.allItems.cg = false;
        this.allItems.vr = false;
        this.allItems.animation = false;
        this.allItems.bim = false;
        this.allItems.other = false;
        this.allItems.cgItems = [];
        this.allItems.vrItems = [];
        this.allItems.animationItems = [];
        this.allItems.bimItems = [];
        this.allItems.otherItems = '';
        this.allItems.files = [];
        this.allItems.projectName = '';
        this.allItems.timeOfDelivery = '';
        this.allItems.scheduledDateOfDelivery = this.scheduledDateOfDelivery;
        this.allItems.additionalUrls = '';
        this.allItems.commentOnDelivery = '';
        this.allItems.drawingNotAvailable = false;
        this.allItems.sunsetOrNightView = false;
        this.allItems.highQuality = false;
        this.allItems.managedBy = null;
        this.allItems.createdBy = null;
    }
}
